module.exports = __webpack_public_path__ + "media/images/logo-indigo-e550f930de1b41be1107bea14806a75d.png";